import React, { useEffect, useState } from 'react';
import { hangUp, toggleMute, useAppCall } from '../services/appCall';
import './CallBar.css';

/* The call in progress — stays on screen on every page until it ends. */
const pretty = (p) => {
  const d = String(p || '').replace(/\D/g, '').slice(-10);
  return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : p;
};
const clock = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};
const LABEL = { connecting: 'Connecting…', ringing: 'Ringing…', ended: 'Call ended', error: 'Call failed' };

export default function CallBar() {
  const call = useAppCall();
  const [, tick] = useState(0);
  useEffect(() => {
    if (call.status !== 'in-call') return undefined;
    const t = setInterval(() => tick((n) => n + 1), 1000);
    return () => clearInterval(t);
  }, [call.status]);
  if (call.status === 'idle') return null;
  const live = ['connecting', 'ringing', 'in-call'].includes(call.status);
  return (
    <div className={`callbar ${call.status}`} role="status">
      <span className="callbar-icon">📞</span>
      <div className="callbar-who">
        <b>{call.name || pretty(call.phone)}</b>
        <span>
          {call.status === 'in-call' ? clock(Date.now() - call.startedAt) : call.status === 'error' ? call.error : LABEL[call.status]}
          {' · from (249) 700-4555'}
        </span>
      </div>
      {live && (
        <>
          <button type="button" className={`callbar-btn${call.muted ? ' on' : ''}`} onClick={toggleMute} disabled={call.status !== 'in-call'}>
            {call.muted ? 'Unmute' : 'Mute'}
          </button>
          <button type="button" className="callbar-btn hang" onClick={hangUp}>
            Hang up
          </button>
        </>
      )}
    </div>
  );
}
